<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chapter-number---IVP sigil_not_in_toc"><span epub:type="pagebreak" id="pagevi" title="vi"></span></h1>
<p class="epi">I am poured out like water, <br/>and all my bones are out of joint; <br/>my heart is like wax; <br/>it is melted within my breast.</p>
<p class="epi_source"><a href="https://www.biblegateway.com/passage/?search=Psalm+22%3A14&amp;version=ESV" target="_blank">Psalm 22:14</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_epigraph.vue?21649e73